import classNames from 'classnames';
import styles from './Dot.module.css';

interface Props {
  isCurrent: boolean;
  onClick?: () => void;
}

const Dot = ({ onClick, isCurrent, ...rest }: Props) => {
  return <div onClick={onClick} className={classNames(styles.dot, { [styles.dotCurrent]: isCurrent })} {...rest} />;
};

export default Dot;
